import React from 'react'
import Button from '@material-ui/core/Button'
import type { ButtonProps } from '@material-ui/core/Button'

import { useUploadImageButtonStyles } from './upload-image-button.styles'
import { useMutationUploadImage } from '../upload-image.mutation'
import { UploadImageOptions, UploadImageResponse } from '../upload-image.types'

type ClassesUploadImageButton = {
  label?: string
  button?: string
}

type UploadImageButtonProps = {
  classes?: ClassesUploadImageButton
  ButtonProps?: ButtonProps
  buttonText?: string
  onUploadImage: (data: UploadImageResponse) => void
  uploadOptions?: UploadImageOptions
}

export const UploadImageButton: React.FC<UploadImageButtonProps> = (props) => {
  const classes = useUploadImageButtonStyles()
  const mutation = useMutationUploadImage({
    onSuccess: (data) => {
      props.onUploadImage(data)
    }
  })

  const handleUploadImage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (file) {
      mutation.mutate({ file, ...props.uploadOptions })
    }
  }

  return (
    <>
      <input
        accept="image/jpeg, image/png"
        className={classes.input}
        onChange={handleUploadImage}
        id="upload-image-file"
        type="file"
      />
      <label htmlFor="upload-image-file" className={props.classes?.label}>
        <Button
          variant="text"
          component="span"
          className={props.classes?.button}
          {...props.ButtonProps}
        >
          {props.buttonText}
        </Button>
      </label>
    </>
  )
}
